export default {
	desinscription: 'Votre demande de désinscription a bien été prise en compte.',
	inactif: 'L’adresse URL demandée n’est plus valide.'
};
